import { render } from "./SideBanner.vue?vue&type=template&id=1a35c68c&scoped=true&ts=true"
import script from "./SideBanner.vue?vue&type=script&lang=ts"
export * from "./SideBanner.vue?vue&type=script&lang=ts"

import "./SideBanner.vue?vue&type=style&index=0&id=1a35c68c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a35c68c"]])

export default __exports__